/*
 * Zamucci — kleine aanvullingen op Horizon.
 * 1. De winkelwagenknop opent de Upcart-winkelwagen (zoals in het vorige theme),
 *    als de Upcart-app geladen is. Anders blijft de Horizon-winkelwagen werken.
 * 2. Bolletjes onder de icoontjes-slider op mobiel.
 */

function openUpcartInsteadOfThemeCart(event) {
  const trigger = event.target.closest('[data-testid="cart-drawer-trigger"]');
  if (!trigger || typeof window.upcartOpenCart !== 'function') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  window.upcartOpenCart();
}

window.addEventListener('click', openUpcartInsteadOfThemeCart, true);

/**
 * Horizon onthoudt een open winkelwagen-paneel tussen pagina's. Met Upcart als
 * winkelwagen hoort dat paneel nooit open te staan, dus sluiten we het meteen.
 */
function closeThemeCartWhenUpcartIsUsed() {
  if (!document.querySelector('script[src*="upcart"]')) return;

  const themeCart = document.getElementById('cart-drawer');
  if (themeCart && themeCart.hasAttribute('open') && typeof themeCart.close === 'function') {
    themeCart.close();
  }

  // Oude, onthouden toestand opruimen zodat de pagina niet smaller blijft
  const savedDrawers = (sessionStorage.getItem('theme-drawer-open') || '')
    .split(',')
    .filter((id) => id && id !== 'cart-drawer');
  if (savedDrawers.length) {
    sessionStorage.setItem('theme-drawer-open', savedDrawers.join(','));
  } else {
    sessionStorage.removeItem('theme-drawer-open');
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
  }
}

if (customElements.get('theme-drawer')) {
  closeThemeCartWhenUpcartIsUsed();
} else {
  customElements.whenDefined('theme-drawer').then(closeThemeCartWhenUpcartIsUsed);
}

function buildSliderDots(track) {
  if (track.dataset.zamucciDots) return;
  const slides = [...track.children];
  if (slides.length < 2) return;
  track.dataset.zamucciDots = 'true';

  const dots = document.createElement('div');
  dots.className = 'zamucci-dots';
  const buttons = slides.map((slide, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
    button.addEventListener('click', () => {
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
    dots.append(button);
    return button;
  });
  track.after(dots);

  const markActive = () => {
    const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    buttons.forEach((button, buttonIndex) => {
      button.setAttribute('aria-current', String(buttonIndex === index));
    });
  };
  track.addEventListener('scroll', markActive, { passive: true });
  markActive();
}

function autoplaySlider(track, seconds) {
  if (track.dataset.zamucciAutoplay) return;
  track.dataset.zamucciAutoplay = 'true';
  let paused = false;
  track.addEventListener('pointerenter', () => (paused = true));
  track.addEventListener('pointerleave', () => (paused = false));
  setInterval(() => {
    if (paused || document.hidden) return;
    const slides = track.children.length;
    const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const next = (index + 1) % slides;
    track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
  }, seconds * 1000);
}

function initSliders() {
  document.querySelectorAll('[id$="__icons"] .layout-panel-flex--row').forEach(buildSliderDots);
  document.querySelectorAll('[id$="__testimonials"] .layout-panel-flex--row').forEach((track) => {
    buildSliderDots(track);
    autoplaySlider(track, 5);
  });
}

initSliders();
document.addEventListener('shopify:section:load', initSliders);
